<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">    
                        <h3 class="blue_accent--text text-uppercase">{{ $t('create_origin_supplier.create') }}</h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                    <v-form ref="form" lazy-validation @submit.prevent="save">
                       <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="origin_supplier.name" :label="$t('create_origin_supplier.name')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-autocomplete class="mt-0 py-0" v-model="origin_supplier.country" :items="countries" :label="$t('create_origin_supplier.country')" :rules="rules_required"></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-row class="px-5 py-0" justify="center">
                        <v-col cols="6" justify="end" align="end">
                            <v-btn class="right px-3 mx-4" @click="cancel">
                                {{ $t('create_origin_supplier.cancel') }}
                            </v-btn>
                            <v-btn class="right white_highlight--text" color="secondary" @click="save">
                                {{ $t('create_origin_supplier.save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>        
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>
export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]}, 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            countries: [],
            origin_supplier: {
                name: '',
                country: '',
                warehouse_id: this.$store.state.warehouseId
            }
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.create_origin_supplier";
    },
    methods: {
        index(){
            this.$store.state.loaderProps.visible = true;
            this.$http.get('https://locations.intech.mx/api/getCountries')
            .then((response) => {
                response.data.forEach((x) => {
                    this.countries.push(x.text);
                })
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        },
        save(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.post(this.$store.state.chronosApi + 'origin_suppliers', this.origin_supplier,{headers: {Authorization: lsToken}})
            .then((response) => {
                response
                this.snackbar = {
                    visible: true,
                    color: 'success2',
                    text: this.$t('create_origin_supplier.created')
                }
                this.$router.push({ name: "OriginSuppliersIndex" });  
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        },
        cancel(){
            this.$router.go(-1);
        },
    },
    watch:{
    }
}
</script>

<style lang="css">
</style>